import { computed } from 'mobx';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContactsValidation } from 'src/core/customValidator/contactsValidator';
import { MaxLength, IsDefined, Validate } from 'class-validator';
import { ClientContactValidation } from 'src/core/customValidator/clientContactValidator';

export class ClientGDPRItemDataService extends DataService<typeof Model.GDPR.Logic.ViewModels.ClientGDPRItem, Model.GDPR.Logic.ViewModels.ClientGDPRItem, ClientGDPRItem> {
	protected map(entity: Model.GDPR.Logic.ViewModels.ClientGDPRItem): ClientGDPRItem {
		return new ClientGDPRItemModel(entity);
    }

	public static make(ctx?: any): ClientGDPRItemDataService {
		return new ClientGDPRItemDataService(ctx, ctx => ctx.ClientsGDPR);
    }
}

export class ClientGDPRItemModel extends EntityModel<Model.GDPR.Logic.ViewModels.ClientGDPRItem, ClientGDPRItem> implements ClientGDPRItem {
	@property<ClientGDPRItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;
	@property<ClientGDPRItemModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;
	@property<ClientGDPRItemModel>(o => o.entity.quotes, (o, value) => o.entity.quotes = value)
	public quotes:any[]
	@property<ClientGDPRItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: Model.Crm.Domain.Models.ClientType;
	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(ContactsValidation)
	@Validate(ClientContactValidation)
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/form/client-gdpr-form.data.ts